import React, { useState, useEffect } from "react";
import "../assets/style/components/CookiePopup.scss";

const COOKIE_NAME = "userConsentGA";
const COOKIE_EXPIRY_DAYS = 150;

export function trackEvent(eventName, params = {}) {
  if (window.gtag) {
    window.gtag("event", eventName, params);
  }
}

function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24*60*60*1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function initGA(){
    if (window.gtag) return; // déjà initialisé

    window.dataLayer = window.dataLayer || [];
    function gtag(){ window.dataLayer.push(arguments); }
    window.gtag = gtag;

    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=G-G01YH6S2EQ`;
    script.async = true;
    document.head.appendChild(script);

    gtag("js", new Date());
    gtag("config", "G-G01YH6S2EQ");
}


const CookiePopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getCookie(COOKIE_NAME);
    if (!consent){
        setVisible(true);
    }else{
        initGA();
    }
  }, []);

  const acceptCookies = () => {
    setCookie(COOKIE_NAME, "true", COOKIE_EXPIRY_DAYS);
    setVisible(false);
    initGA();
  };

  const refuseCookies = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-popup">
      <p className="cookie-text">
        Ce site utilise des cookies afin d’améliorer votre expérience de navigation.
      </p>
      <div className="d-flex gap-2">
        <button className="action-btn" onClick={acceptCookies}>
            <div>Accepter</div>
        </button>
        <button className="action-btn negative" onClick={refuseCookies}>
            <div>Refuser</div>
        </button>
      </div>
    </div>
  );
};

export default CookiePopup;
